import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { setLanguage } from 'actions/App';
import PopoutDropdown from "components/PopoutDropdown";
import languageData from "lngProvider/data";

const LanguageSwitcher = () => {
  const dispatch = useDispatch();
  const locale = useSelector((state) => state.app.locale);
  return (
    <PopoutDropdown
      id="Language-Switcher-Dropdown"
      dataCy="Language-Switcher-Dropdown"
      align="left"
      direction="up"
      buttonIcon="chevronUp"
      secondaryIcon="globe"
      label={locale.charAt(0).toUpperCase() + locale.slice(1)}
      options={languageData && languageData.map(l => { return { name: l.name, value: l.locale } })}
      onOptionSelect={(option) => dispatch(setLanguage(option))}
    />
  )
}

export default LanguageSwitcher;